import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials, aboutFeatures } from '@/mocks/testimonials';

export default function About() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[320px] md:h-[420px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20brand%20identity%20scene%20with%20warm%20golden%20lighting%2C%20abstract%20geometric%20shapes%2C%20soft%20shadows%2C%20luxurious%20texture%2C%20professional%20editorial%20photography%2C%20clean%20cream%20and%20beige%20background%2C%20sophisticated%20mood&width=1800&height=700&seq=about-hero-001&orientation=landscape"
            alt="91免费 - 关于我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-3xl md:text-5xl font-black font-sans text-background-50">
              关于
              <span className="font-heading italic text-primary-400">我们</span>
            </h1>
            <p className="mt-3 text-sm md:text-base text-background-50/70 font-light max-w-lg mx-auto">
              了解91免费的品牌故事与发展历程
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50 py-10 md:py-16">
          <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
            <div className="mb-8">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 pb-14 md:pb-20">
          <div className="w-full px-4 md:px-8 max-w-[1000px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-black font-sans text-foreground-950 leading-tight">
                专注娱乐资讯
              </h2>
              <p className="text-2xl md:text-3xl lg:text-4xl font-heading italic text-primary-500 mt-1">
                深耕吃瓜文化
              </p>
              <p className="text-2xl md:text-3xl lg:text-4xl font-black font-sans text-foreground-950 mt-1">
                做最懂你的八卦平台
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-primary-100 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                <span className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/80 cursor-pointer">
                  <i className="ri-arrow-right-up-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-6xl md:text-7xl font-heading font-black text-primary-500 italic">
                  5年
                </div>
                <p className="mt-4 text-lg font-semibold text-foreground-950">
                  深耕娱乐八卦领域
                </p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  自2021年创立以来，我们始终坚持为用户提供最新、最全的娱乐资讯和深度八卦内容。
                </p>
                <p className="mt-4 text-sm font-heading italic text-primary-600">
                  让吃瓜成为一种生活方式
                </p>
              </div>
              <div className="bg-accent-100 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                <span className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/80 cursor-pointer">
                  <i className="ri-arrow-right-up-line text-secondary-700 text-sm"></i>
                </span>
                <div className="text-6xl md:text-7xl font-heading font-black text-secondary-600 italic">
                  100万+
                </div>
                <p className="mt-4 text-lg font-semibold text-foreground-950">
                  活跃用户信赖
                </p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  平台累计注册用户超过百万，日均活跃用户数十万，是业内最具影响力的娱乐资讯平台之一。
                </p>
                <p className="mt-4 text-sm font-heading italic text-secondary-700">
                  百万吃瓜群众的选择
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <span className="inline-flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                用户口碑
              </span>
              <h2 className="mt-3 text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950">
                听听吃瓜群众怎么说
              </h2>
              <p className="mt-2 text-sm text-foreground-500">真实用户评价，口碑相传</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((t, i) => (
                <div
                  key={t.id}
                  className={`bg-background-50 rounded-2xl p-6 ${i === testimonials.length - 1 ? 'opacity-50' : ''}`}
                >
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(5)].map((_, si) => (
                      <span key={si} className={`w-4 h-4 flex items-center justify-center ${si < t.rating ? 'text-primary-500' : 'text-foreground-300'}`}>
                        <i className={`${si < t.rating ? 'ri-star-fill' : 'ri-star-line'} text-sm`}></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-950 font-semibold mb-2">
                    {t.content.slice(0, 40)}...
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                    {t.content}
                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
            <div className="flex flex-col items-start gap-3 mb-14">
              <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider">
                服务特色
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight tracking-tight">
                全方位娱乐资讯服务
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {aboutFeatures.map((feature) => (
                <div key={feature.id} className="bg-background-100 rounded-2xl p-8 transition-all duration-300">
                  <span className="w-14 h-14 flex items-center justify-center">
                    <i className={`${feature.icon} text-3xl text-foreground-950`}></i>
                  </span>
                  <h3 className="mt-5 text-lg font-bold text-foreground-950">
                    {feature.title}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed font-light">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-8 max-w-[1000px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-black text-foreground-950">联系我们</h2>
              <p className="mt-2 text-sm text-foreground-500">有任何问题或合作意向，欢迎随时联系</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-2xl p-8 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto">
                  <i className="ri-mail-line text-2xl text-primary-500"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">商务合作</h3>
                <p className="mt-2 text-sm text-foreground-600">business@91free.com</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-8 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto">
                  <i className="ri-customer-service-line text-2xl text-primary-500"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">客服热线</h3>
                <p className="mt-2 text-sm text-foreground-600">400-888-9191</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-8 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto">
                  <i className="ri-map-pin-line text-2xl text-primary-500"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">公司地址</h3>
                <p className="mt-2 text-sm text-foreground-600">北京市朝阳区建国路88号</p>
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于91免费',
              description: '91免费品牌介绍 - 领先的娱乐八卦资讯平台，深耕吃瓜文化，服务百万用户。',
              mainEntity: {
                '@type': 'Organization',
                name: '91免费',
                url: 'https://www.91free.com',
                description: '领先的娱乐八卦资讯平台',
                foundingDate: '2021',
                address: {
                  '@type': 'PostalAddress',
                  streetAddress: '建国路88号SOHO现代城A座',
                  addressLocality: '北京',
                  addressRegion: '朝阳区',
                  addressCountry: 'CN',
                },
                contactPoint: {
                  '@type': 'ContactPoint',
                  telephone: '400-888-9191',
                  contactType: 'customer service',
                  email: 'contact@91free.com',
                },
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.91free.com',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}